let formSuccGreen = '#008000',
 formSuccRed = '#ff0000';

var apiUrl = 'https://form.mozaico.com';

const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.heic', '.pdf', '.doc', '.docx'];
const maxFileSize = 5 * 1024 * 1024; // 5 MB

// For All Forms
let captchaAnswers = {};
function getRandomInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min }
function generateCaptcha(captchaTextId) {
    let num1 = getRandomInt(1, 9);
    let num2 = getRandomInt(1, 9);
    let captchaAnswer = num1 + num2;

    document.getElementById(captchaTextId).innerText = `${num1} + ${num2} = `;
    let inputId = captchaTextId.replace('text', 'input');
    document.getElementById(inputId).value = ''; // Clear the input field

    // Store the answer for this captcha
    captchaAnswers[captchaTextId] = captchaAnswer;
}
function formValidateCaptcha(captchaInputId) {

    let userCaptcha = parseInt(document.getElementById(captchaInputId).value, 10);
    let txtId = captchaInputId.replace('input', 'text');

    if (userCaptcha === captchaAnswers[txtId]) {
        console.log('Captcha verified successfully!');
        return true; // Allow form submission
    } else {
        console.log('Incorrect captcha. Please try again.');
        generateCaptcha(txtId); // Generate a new captcha
        return false; // Prevent form submission
    }
}

// For Collaboration forms
let ClasscaptchaAnswer;
function ClassGenerateCaptcha() {
    let num1 = getRandomInt(1, 9);
    let num2 = getRandomInt(1, 9);
    ClasscaptchaAnswer = num1 + num2;

    document.querySelectorAll('.multi_collabo_form_captcha--text').forEach( e => e.innerText = `${num1} + ${num2} = `);
    document.querySelectorAll('.multi_collabo_form_captcha--input').forEach( e => e.value = '');
}
function ClassValidateCaptcha(parent) {
    let userCaptcha = parseInt(parent.querySelector('.multi_collabo_form_captcha--input').value, 10);
    
    if (userCaptcha === ClasscaptchaAnswer) {
        console.log('Captcha verified successfully!');
        return true; // Allow form submission
    } else {
        console.log('Incorrect captcha. Please try again.');
        ClassGenerateCaptcha(); // Generate a new captcha
        return false; // Prevent form submission
    }
}

document.getElementById('mw_help_box_captcha--text') ? generateCaptcha('mw_help_box_captcha--text') : '';
document.getElementById('cstmze_your_size_captcha--text') ? generateCaptcha('cstmze_your_size_captcha--text') : '';
document.getElementById('cstmze_size_color_captcha--text') ? generateCaptcha('cstmze_size_color_captcha--text') : '';
document.getElementById('inq_abt_prd_captcha--text') ? generateCaptcha('inq_abt_prd_captcha--text') : '';
document.getElementById('inq_abt_dsgn_captcha--text') ? generateCaptcha('inq_abt_dsgn_captcha--text') : '';
document.getElementById('ctm_comm_form_captcha--text') ? generateCaptcha('ctm_comm_form_captcha--text') : '';
document.getElementById('ctm_cntct_form_captcha--text') ? generateCaptcha('ctm_cntct_form_captcha--text') : '';
document.getElementById('ctm_mosa_kit_captcha--text') ? generateCaptcha('ctm_mosa_kit_captcha--text') : '';
document.getElementById('crprt_mosa_log_captcha--text') ? generateCaptcha('crprt_mosa_log_captcha--text') : '';
document.getElementById('artst_collab_form_captcha--text') ? generateCaptcha('artst_collab_form_captcha--text') : '';
document.querySelectorAll('.multi_collabo_form_captcha--text') ? ClassGenerateCaptcha() : '';

// Check for required fields for Collaboration Forms
const collabFieldsJson = {
    "Affiliates":[ "firstName", "lastName", "webBlogUrl", "email", "phoneNumber", "paypalEmail", "message" ],
    "Dealers":[ "firstName", "lastName", "email", "phoneNumber", "companyName", "companyAddress", "WebUrl", "taxId", "paypalAcc", "checkPayableTo" ],
    "Online Retailers/Associates":[ "firstName", "lastName", "email", "phoneNumber", "companyName", "WebUrl", "paypalAcc", "checkPayableTo" ],
    "On-Site Architects / Designers":[ "firstName", "lastName", "email", "phoneNumber", "companyName", "WebUrl", "paypalAcc", "checkPayableTo" ],
    "Give Back Through Art":[ "firstName", "lastName", "email", "phoneNumber", "uniName"],
    "International Entrepreneurship Program":[ "firstName", "lastName", "email", "phoneNumber", "taxId", "WebUrl", "paypalAcc", "checkPayableTo", "mrktPrd" ]
}
function isFormFilled(form, subject) {
    const fields = collabFieldsJson[subject];
    
    for (let field of fields) {
        const input = form.querySelector(`[name="${field}"]`);
        if (!input || input.value.trim() === '') { return false }
    }

    return true;
}


// Close Event for all success messages 
document.querySelectorAll('.form_success_msg--close')?.forEach( e => {
    e.addEventListener('click', (elm) => {
        elm.target.closest('.form_success_msg').style.display = 'none';
    })
})

function formProgressbar(parent, state ){
    let progressBar = parent.querySelectorAll('.progress-bar');
    let progressBarInner = parent.querySelectorAll('.progress-bar-inner');

    if(state == 'show') {
        progressBarInner.forEach(e => e.style.width = '0%');
        progressBar.forEach(e => e.style.display = 'block');
        parent.querySelector('.ctm_form_loader_with_img').style.display = 'flex';
    }
    if(state == 'showSpace') {
        if(parent.querySelector('.progress-bar.spacefile')){
            parent.querySelector('.progress-bar.spacefile').style.display = 'block';
            progressBarInner.forEach(e => e.style.width = '0%');
            parent.querySelector('.ctm_form_loader_with_img').style.display = 'flex';
        }
    }
    if(state == 'showDesign') {
        if(parent.querySelector('.progress-bar.designfile')){
            parent.querySelector('.progress-bar.designfile').style.display = 'block';
            progressBarInner.forEach(e => e.style.width = '0%');
            parent.querySelector('.ctm_form_loader_with_img').style.display = 'flex';
        }
    }

    state == 'hide' ? setTimeout(() => { 
        progressBar.forEach(e => e.style.display = 'none');
        parent.querySelector('.ctm_form_loader_with_img').style.display = 'none';
    }, 300) : '' ;
    if(state == '100'){
        progressBarInner.forEach(e => e.style.width = '100%');
        setTimeout(() => { 
            progressBar.forEach(e => e.style.display = 'none') 
            parent.querySelector('.ctm_form_loader_with_img').style.display = 'none';
        }, 300);
    }
    if(state == 'fakeProgress'){
        const progressSteps = [12, 35, 52, 68, 87];
        let currentStep = 0;

        let fakeProgressInterval = setInterval(function () {
            if (currentStep < progressSteps.length) {
                let progress = progressSteps[currentStep];
                // progressBarInner.style.width = progress + '%';
                progressBarInner.forEach(e => e.style.width = progress + '%');
                currentStep++;
            } else {
                clearInterval(fakeProgressInterval);
            }
        }, 600);
    }
}
// Success Message
function ShowSuccessMsg(parent,color, msg ){
    parent.classList.remove('show_loader');
    parent.querySelector('.form_success_msg').style.setProperty('--f-succ-color', color);
    parent.querySelector('.form_success_msg').style.display = 'flex';
    parent.querySelector('.form_success_msg span').innerHTML = msg;
}
//If its Email or not
function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
}
function validateImage(file) {
    const ext = '.' + file.name.split('.').pop().toLowerCase();
    
    try {
        if (!allowedExtensions.includes(ext)) { throw new Error('File type not supported. Allowed types: ' + allowedExtensions.join(', ')) }
        if (file.size > maxFileSize) { throw new Error('File size exceeds the limit of 5MB.') }
        return true;
    } catch (error) { return false }
}

// Need Help Form AJAX submission -- ctm-need-help-form  ////////////////////////////////////////////////////
function needHelp(e) {
    e.preventDefault();

    const form = document.getElementById('mw_help_box--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.mw_help_box');

    let question = form.querySelector('[name="question"]').value;
    let name = form.querySelector('[name="name"]').value;
    let email = form.querySelector('[name="email"]').value;
    let fileInput = form.querySelector('[name="file"]');
        
    if( formValidateCaptcha('mw_help_box_captcha--input') && validateEmail(email) && question && name && email){

        // Append additional fields if not already in formData
        if (!formData.has('question')) { formData.append('question', question) }
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        // if (!formData.has('file')) { if (fileInput.files.length > 0) { formData.append('file', fileInput.files[0], fileInput.files[0].name) } }     
        if (fileInput.files.length > 0) {
            let file = fileInput.files[0];
            if (validateImage(file)) {
                if (!formData.has('file')) { formData.append('file', file, file.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
                return; // Stop further processing
            }
        }
        
        generateCaptcha('mw_help_box_captcha--text');
        fileInput.files.length > 0 ? formProgressbar(parent, 'show') : parent.classList.add('show_loader') ;
        formProgressbar(parent, 'fakeProgress' );
    
        fetch( apiUrl + '/form/need-help', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , 'Thank You!' ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{   
        formProgressbar(parent, 'hide' );
        if(!formValidateCaptcha('mw_help_box_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
        else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }

        
    }    
}
function showNeedHelp(e){  if(e.target.closest('#mw_need_help_btn')) { document.querySelector('.mw_help_box--wrapper').style.display = 'grid' } }

document.getElementById('mw_help_box--submit')?.addEventListener('click', (e) => needHelp(e) );
document.getElementById('mw_need_help_btn')?.addEventListener('click', (e) => showNeedHelp(e));
document.getElementById('mw_help_box--close')?.addEventListener('click', (elm) => { elm.target.closest('.mw_help_box--wrapper').style.display = 'none' })
// Need Help Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Customize your Mosaic Form AJAX submission -- ctm-customize-your-mosaic //////////////////////////////////
function customizeYourMosaic(e) {
        
    e.preventDefault();

    const form = document.getElementById('cstmze_your_size--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.cstmze_your_size');

    let size = form.querySelector('[name="size"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let other = form.querySelector('[name="other"]').value;
    let name = form.querySelector('[name="name"]').value;
    let email = form.querySelector('[name="email"]').value;
    let fileInput = form.querySelector('[name="file"]');
    
    if( formValidateCaptcha('cstmze_your_size_captcha--input') && validateEmail(email) && size && name && email && phoneNumber){
    
        // Append additional fields if not already in formData
        if (!formData.has('size')) { formData.append('size', size) }
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('other')) { formData.append('other', other) }
        // if (!formData.has('file')) { if (fileInput.files.length > 0) { formData.append('file', fileInput.files[0], fileInput.files[0].name) }}
        if (fileInput.files.length > 0) {
            let file = fileInput.files[0];
            if (validateImage(file)) {
                if (!formData.has('file')) { formData.append('file', file, file.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }

        generateCaptcha('cstmze_your_size_captcha--text');  
        // parent.classList.add('show_loader');
        fileInput.files.length > 0 ? formProgressbar(parent, 'show') : parent.classList.add('show_loader') ;
        formProgressbar(parent, 'fakeProgress' );    
    
        fetch( apiUrl + '/form/customize-your-mosaic', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();    
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you! We'll be in touch." ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        formProgressbar(parent, 'hide' );
        
        if(!validateEmail(email)){
            form.querySelector('.cus_email_field span').style.opacity = '1';
            setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
            // console.log('Email is invalid');
        }

        ShowSuccessMsg( parent , formSuccRed , 'Fill the required fields correctly.' );
        setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        
        // if(!formValidateCaptcha('mw_help_box_captcha--input')){
        //     ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
        //     setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        // }

    }
}
document.getElementById('cstmze_your_size--button')?.addEventListener('click', (e) => { if(e.target.closest('#cstmze_your_size--button')){customizeYourMosaic(e)} } );
// Customize your Mosaic Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Custom Size Color Form AJAX submission -- custom-size-form ////////////////////////////////////////////
function  ctsmzeSizeColor(e) {
    
    e.preventDefault();

    const form = document.getElementById('cstmze_size_color--form');
    let formData = new FormData(form);

    let parent = e.target.closest('.cstmze_size_color');

    let name = form.querySelector('[name="name"]').value;
    let width = form.querySelector('[name="width"]').value;
    let height = form.querySelector('[name="height"]').value;
    let size = form.querySelector('[name="size"]').value;
    let email = form.querySelector('[name="email"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let product = form.querySelector('[name="product"]').value;
    let sizeColor = form.querySelector('[name="sizeColor"]').value;
    let poductTemplate = form.querySelector('[name="poductTemplate"]').value;
    // if(poductTemplate == '' || poductTemplate == null){ poductTemplate = 'Default-Product' }
    
    if( formValidateCaptcha('cstmze_size_color_captcha--input') && validateEmail(email) && name && width && height && size && email && phoneNumber && product && sizeColor ){
    
        // Append additional fields if not already in formData
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('width')) { formData.append('width', width) }
        if (!formData.has('height')) { formData.append('height', height) }
        if (!formData.has('size')) { formData.append('size', size) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('product')) { formData.append('product', product) }
        if (!formData.has('sizeColor')) { formData.append('sizeColor', sizeColor) }
        if (!formData.has('poductTemplate')) { formData.append('poductTemplate', poductTemplate) }
        
        // console.log(name +' ---- '+ width +' ---- '+ height +' ---- '+ size +' ---- '+ email +' ---- '+ phoneNumber +' ---- '+ product +' ---- '+ sizeColor);
        // console.log('poductTemplate', poductTemplate);
        // formData.forEach((value, key) => {
        //     console.log(key, value);
        // });

        generateCaptcha('cstmze_size_color_captcha--text'); 
        parent.classList.add('show_loader');
    
        fetch( apiUrl + '/form/custom-size-color', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thanks! We'll notify you about the price soon." ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        if(!formValidateCaptcha('cstmze_size_color_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }            
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('cstmze_size_color--button')?.addEventListener('click', (e) => { if(e.target.closest('#cstmze_size_color--button')){ ctsmzeSizeColor(e)} } );
// Custom Size Color Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Inquiry About Profuct Form AJAX submission -- product-inquire-form ////////////////////////////////////////////
function  inqAbtPrd(e) {
    
    e.preventDefault();

    const form = document.getElementById('inq_abt_prd--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.inq_abt_prd');

    let name = form.querySelector('[name="name"]').value;
    let email = form.querySelector('[name="email"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let product = form.querySelector('[name="product"]').value;
    let message = form.querySelector('[name="message"]').value;
    let poductTemplate = form.querySelector('[name="poductTemplate"]').value;
    if(poductTemplate == '' || poductTemplate == null){ poductTemplate = 'Default-Product' }
    
    if( formValidateCaptcha('inq_abt_prd_captcha--input') && validateEmail(email) && name && email && phoneNumber && product && message ){
    
        // Append additional fields if not already in formData
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('product')) { formData.append('product', product) }
        if (!formData.has('message')) { formData.append('message', message) }
        if (!formData.has('poductTemplate')) { formData.append('poductTemplate', poductTemplate) }

        generateCaptcha('inq_abt_prd_captcha--text');  
        parent.classList.add('show_loader');
    
        fetch( apiUrl + '/form/inquire-about-product', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank You for contacting us." ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        if(!formValidateCaptcha('inq_abt_prd_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }            
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('inq_abt_prd--button')?.addEventListener('click', (e) => { if(e.target.closest('#inq_abt_prd--button')){ inqAbtPrd(e)} } );
// Inquiry About Profuct Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Inquiry About Design Form AJAX submission -- contact-form-mds //////////////////////////////////
function inqAbtDsgn(e) {
        
    e.preventDefault();

    const form = document.getElementById('inq_abt_dsgn--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.inq_abt_dsgn');

    let firstName = form.querySelector('[name="firstName"]').value; 
    let lastName = form.querySelector('[name="lastName"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let fileInput = form.querySelector('[name="file"]');
    let message = form.querySelector('[name="message"]').value;
    let page = form.querySelector('[name="page"]').value;
    
    if( formValidateCaptcha('inq_abt_dsgn_captcha--input') && validateEmail(email) && email ){
    
        // Append additional fields if not already in formData
        if (!formData.has('firstName')) { formData.append('firstName', firstName) }
        if (!formData.has('lastName')) { formData.append('lastName', lastName) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('message')) { formData.append('message', message) }
        if (!formData.has('page')) { formData.append('page', page) }
        // if (!formData.has('file')) { if (fileInput.files.length > 0) { formData.append('file', fileInput.files[0], fileInput.files[0].name) }}
        if (fileInput.files.length > 0) {
            let file = fileInput.files[0];
            if (validateImage(file)) {
                if (!formData.has('file')) { formData.append('file', file, file.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }

        generateCaptcha('inq_abt_dsgn_captcha--text');  
        // parent.classList.add('show_loader');
        fileInput.files.length > 0 ? formProgressbar(parent, 'show') : parent.classList.add('show_loader') ;
        formProgressbar(parent, 'fakeProgress' );
    
        fetch( apiUrl + '/form/inquire-about-design', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you! We'll be in touch." ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        formProgressbar(parent, 'hide' );
        if(!formValidateCaptcha('inq_abt_dsgn_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('inq_abt_dsgn--button')?.addEventListener('click', (e) => { if(e.target.closest('#inq_abt_dsgn--button')){inqAbtDsgn(e)} } );
// Inquiry About Design Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Commercial Form AJAX submission -- commercial-form //////////////////////////////////
function commercialForm(e) {
        
    e.preventDefault();

    const form = document.getElementById('ctm_comm_form--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.ctm_comm_form');

    let name = form.querySelector('[name="name"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let note = form.querySelector('[name="note"]').value; 
    let unit = form.querySelector('[name="unit"]').value; 
    let width = form.querySelector('[name="width"]').value; 
    let height = form.querySelector('[name="height"]').value; 
    let spaceFile = form.querySelector('[name="spaceFile"]');
    let designFile = form.querySelector('[name="designFile"]');
    let page = form.querySelector('[name="page"]').value;      
    
    if( formValidateCaptcha('ctm_comm_form_captcha--input') && validateEmail(email) && name && email && unit && width && height ){
    
        // Append additional fields if not already in formData
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('note')) { formData.append('note', note) }
        if (!formData.has('unit')) { formData.append('unit', unit) }
        if (!formData.has('width')) { formData.append('width', width) }
        if (!formData.has('height')) { formData.append('height', height) }
        if (!formData.has('page')) { formData.append('page', page) }

        if (spaceFile.files.length > 0) {
            let spaceFile2 = spaceFile.files[0];
            if (validateImage(spaceFile2)) {
                if (!formData.has('spaceFile')) { formData.append('spaceFile', spaceFile2, spaceFile2.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid Space File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }
        if (designFile.files.length > 0) {
            let designFile2 = designFile.files[0];
            if (validateImage(designFile2)) {
                if (!formData.has('designFile')) { formData.append('designFile', designFile2, designFile2.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid Design File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }

        generateCaptcha('ctm_comm_form_captcha--text');       
        // parent.classList.add('show_loader');
        designFile.files.length > 0 ? formProgressbar(parent, 'showDesign') : '';
        spaceFile.files.length > 0 ? formProgressbar(parent, 'showSpace') : '';
        designFile.files.length == 0 && spaceFile.files.length == 0 ? parent.classList.add('show_loader') : '';
        formProgressbar(parent, 'fakeProgress' );
    
        fetch( apiUrl + '/form/commercial', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you! We'll be in touch." ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        formProgressbar(parent, 'hide' );
        if(!formValidateCaptcha('ctm_comm_form_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('ctm_comm_form--button')?.addEventListener('click', (e) => { if(e.target.closest('#ctm_comm_form--button')){commercialForm(e)} } );
// Commercial Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Contact Form AJAX submission -- contact-form //////////////////////////////////
function contactForm(e) {
        
    e.preventDefault();

    const form = document.getElementById('ctm_cntct_form--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.ctm_cntct_form');

    let firstName = form.querySelector('[name="firstName"]').value; 
    let lastName = form.querySelector('[name="lastName"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let subject = form.querySelector('[name="subject"]').value; 
    let message = form.querySelector('[name="message"]').value; 
    
    
    if( formValidateCaptcha('ctm_cntct_form_captcha--input') && validateEmail(email) && firstName && lastName && email && phoneNumber && subject && message  ){
    
        // Append additional fields if not already in formData
        if (!formData.has('firstName')) { formData.append('firstName', firstName) }
        if (!formData.has('lastName')) { formData.append('lastName', lastName) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('subject')) { formData.append('subject', subject) }
        if (!formData.has('message')) { formData.append('message', message) }

        generateCaptcha('ctm_cntct_form_captcha--text')
        parent.classList.add('show_loader');
    
        fetch( apiUrl + '/form/contact-us', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you!" ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        if(!formValidateCaptcha('ctm_cntct_form_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('ctm_cntct_form--button')?.addEventListener('click', (e) => { if(e.target.closest('#ctm_cntct_form--button')){contactForm(e)} } );
// Contact Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Mosaic Kit Form AJAX submission -- kit-form //////////////////////////////////
function mosaicKit(e) {
        
    e.preventDefault();

    const form = document.getElementById('ctm_mosa_kit--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.ctm_mosa_kit');

    let name = form.querySelector('[name="name"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let size = form.querySelector('[name="size"]').value; 
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let fileInput = form.querySelector('[name="file"]');
    let other = form.querySelector('[name="other"]').value;
    
    
    if( formValidateCaptcha('ctm_mosa_kit_captcha--input') && validateEmail(email) && name && email && size && fileInput.files.length > 0 ){
    
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('size')) { formData.append('size', size) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('other')) { formData.append('other', other) }
        // if (!formData.has('file')) { if (fileInput.files.length > 0) { formData.append('file', fileInput.files[0], fileInput.files[0].name) }}

        if (fileInput.files.length > 0) {
            let file = fileInput.files[0];
            if (validateImage(file)) {
                if (!formData.has('file')) { formData.append('file', file, file.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }    

        generateCaptcha('ctm_mosa_kit_captcha--text');
        // parent.classList.add('show_loader');
        fileInput.files.length > 0 ? formProgressbar(parent, 'show') : parent.classList.add('show_loader') ;
        formProgressbar(parent, 'fakeProgress' );
    
        fetch( apiUrl + '/form/mosaic-kit', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you!" ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the required fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        formProgressbar(parent, 'hide' );
        if(!formValidateCaptcha('ctm_mosa_kit_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('ctm_mosa_kit--button')?.addEventListener('click', (e) => { if(e.target.closest('#ctm_mosa_kit--button')){mosaicKit(e)} } );
// Mosaic Kit Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Corporate Mosaic Logos Form AJAX submission -- ctm-corporate-mosaic-logos-form //////////////////////////////////
function corporateMosaLogs(e) {
        
    e.preventDefault();

    const form = document.getElementById('crprt_mosa_log--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.crprt_mosa_log');

    let name = form.querySelector('[name="name"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let size = form.querySelector('[name="size"]').value; 
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;
    let fileInput = form.querySelector('[name="file"]');
    let other = form.querySelector('[name="other"]').value;
    
    
    if( formValidateCaptcha('crprt_mosa_log_captcha--input') && validateEmail(email) && name && email && size && phoneNumber ){
    
        if (!formData.has('name')) { formData.append('name', name) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('size')) { formData.append('size', size) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
        if (!formData.has('other')) { formData.append('other', other) }
        if (!formData.has('file')) { if (fileInput.files.length > 0) { formData.append('file', fileInput.files[0], fileInput.files[0].name) }}

        if (fileInput.files.length > 0) {
            let file = fileInput.files[0];
            if (validateImage(file)) {
                if (!formData.has('file')) { formData.append('file', file, file.name) }
            } else {
                ShowSuccessMsg(parent, formSuccRed, 'Invalid File. </br>Max size: 5mb. </br>Allowed Files: .jpg, .JPG, .jpeg, .png, .webp, .heic, .pdf, .doc, .docx');
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 2000)
                return; // Stop further processing
            }
        }
    
        generateCaptcha('crprt_mosa_log_captcha--text');
        // parent.classList.add('show_loader');
        fileInput.files.length > 0 ? formProgressbar(parent, 'show') : parent.classList.add('show_loader') ;
        formProgressbar(parent, 'fakeProgress' );
    
        fetch( apiUrl + '/form/corporate-mosaic-logos', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();
            formProgressbar(parent, '100' );

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you!" ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the required fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            formProgressbar(parent, 'hide' );
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        formProgressbar(parent, 'hide' );
        if(!formValidateCaptcha('crprt_mosa_log_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }            
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('crprt_mosa_log--button')?.addEventListener('click', (e) => { if(e.target.closest('#crprt_mosa_log--button')){corporateMosaLogs(e)} } );
// Corporate Mosaic Logos Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Corporate Mosaic Logos Form AJAX submission -- main-page //////////////////////////////////
function artistCollaboration(e) {
        
    e.preventDefault();

    const form = document.getElementById('artst_collab_form--form');
    const formData = new FormData(form);

    let parent = e.target.closest('.artst_collab_form');

    let firstName = form.querySelector('[name="firstName"]').value; 
    let city = form.querySelector('[name="city"]').value; 
    let portfolioUrl = form.querySelector('[name="portfolioUrl"]').value; 
    let socialAccounts = form.querySelector('[name="socialAccounts"]').value; 
    let email = form.querySelector('[name="email"]').value;
    let countryCode = form.querySelector('[name="countryCode"]').value;
    let phoneNumber = form.querySelector('[name="phoneNumber"]').value;    
    
    
    if( formValidateCaptcha('artst_collab_form_captcha--input') && validateEmail(email) && firstName && email && phoneNumber ){
    
        if (!formData.has('firstName')) { formData.append('firstName', firstName) }
        if (!formData.has('city')) { formData.append('city', city) }
        if (!formData.has('portfolioUrl')) { formData.append('portfolioUrl', portfolioUrl) }
        if (!formData.has('socialAccounts')) { formData.append('socialAccounts', socialAccounts) }
        if (!formData.has('email')) { formData.append('email', email) }
        if (!formData.has('countryCode')) { formData.append('countryCode', countryCode) }
        if (!formData.has('phoneNumber')) { formData.append('phoneNumber', phoneNumber) }
    

        generateCaptcha('artst_collab_form_captcha--text')
        parent.classList.add('show_loader');
    
        fetch( apiUrl + '/form/artist-collaboration', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you!" ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the required fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });
    }else{
        if(!formValidateCaptcha('artst_collab_form_captcha--input')){
            ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }else{
            if(!validateEmail(email)){
                form.querySelector('.cus_email_field span').style.opacity = '1';
                setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);            
                // console.log('Email is invalid');
            }
            ShowSuccessMsg( parent , formSuccRed , 'Fill all the fields correctly.' );
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
        }
    }
}
document.getElementById('artst_collab_form--button')?.addEventListener('click', (e) => { if(e.target.closest('#artst_collab_form--button')){artistCollaboration(e)} } );
// Corporate Mosaic Logos Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


// Corporate Mosaic Logos Form AJAX submission -- contact-form-mds //////////////////////////////////
function  Collaboration(e) {
        
    e.preventDefault();

    const form = e.target.closest('form');
    const formData = new FormData(form);

    let parent = e.target.closest('.multi_collabo_form');

    let email = form.querySelector('[name="email"]').value;
    let subject = form.querySelector('[name="subject"]').value; 
    // let city = form.querySelector('[name="city"]').value; 

    if(!ClassValidateCaptcha(parent)){
        ShowSuccessMsg( parent , formSuccRed , 'Incorrect Captcha' );
        setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)

    }else if(!validateEmail(email)  ){
        form.querySelector('.cus_email_field span').style.opacity = '1';
        setTimeout(() => { form.querySelector('.cus_email_field span').style.opacity = '0' }, 2000);  
        // console.log('Email is invalid');
        
        ShowSuccessMsg( parent , formSuccRed , 'Fill the required fields correctly.' );
        setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)

    }else if( !isFormFilled(form, subject) ){
        ShowSuccessMsg( parent , formSuccRed , 'Fill the required fields correctly.' );
        setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)

    }else{
        ClassGenerateCaptcha();
        parent.classList.add('show_loader');
    
        fetch( apiUrl + '/form/collaboration', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            form.reset();

            // setTimeout(() => {
                if(json.msg == 200){ ShowSuccessMsg( parent , formSuccGreen , "Thank you!" ) }
                else if(json.msg == 400 || json.msg == 'fill all required fields' ){ ShowSuccessMsg( parent , formSuccRed , 'Fill all the required fields correctly.' )}
                setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            // }, 1000)
        })
        .catch(error => {
            setTimeout(() => { ShowSuccessMsg( parent , formSuccRed , 'Server Error, Try again after some time.' ) }, 2000)
            setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none';}, 10000)
            console.warn('Error:', error);
        });

    }
    // else{
    //     ShowSuccessMsg( parent , formSuccRed , 'Fill the required fields correctly.' );
    //     setTimeout(() => { parent.querySelector('.form_success_msg').style.display = 'none' }, 2000)
    // }
}
document.querySelectorAll('.multi_collabo_form--button').forEach(elm => elm.addEventListener('click', (e) => { if(e.target.closest('.multi_collabo_form--button')){ Collaboration(e)} } ))
// Corporate Mosaic Logos Form End \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\